import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const customerApi = axios.create({ baseURL: `${API}/customer`, withCredentials: true });
export const paymentsApi = axios.create({ baseURL: `${API}/payments`, withCredentials: true });

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [entitlements, setEntitlements] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadEntitlements = useCallback(async () => {
    try {
      const r = await customerApi.get("/entitlements");
      setEntitlements(r.data.entitlements || []);
    } catch {
      setEntitlements([]);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const r = await customerApi.get("/me");
      setUser(r.data);
      await loadEntitlements();
    } catch {
      setUser(null);
      setEntitlements([]);
    } finally {
      setLoading(false);
    }
  }, [loadEntitlements]);

  useEffect(() => {
    // CRITICAL: returning from Google OAuth callback — AuthCallback exchanges
    // the session_id and establishes the session first; skip the /me check here.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const setUserAndSync = async (u) => {
    setUser(u);
    if (u) await loadEntitlements();
    else setEntitlements([]);
  };

  const logout = async () => {
    await customerApi.post("/logout").catch(() => {});
    setUser(null);
    setEntitlements([]);
  };

  /** Unico modo di verificare le capability lato client: has("DOWNLOAD_REPORT") ecc. */
  const has = useCallback((ent) => entitlements.includes(ent), [entitlements]);

  return (
    <CustomerAuthContext.Provider value={{ user, entitlements, has, loading, setUser: setUserAndSync, logout, refresh: checkAuth }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export const useCustomerAuth = () => useContext(CustomerAuthContext);
